// src/components/courses/CourseList.jsx
import React, { useState, useEffect } from 'react';
import styles from './CourseList.module.css';
import CourseCardDetailed from './CourseCardDetailed';
import allCoursesData from '../../data/courses'; // Import your hardcoded data

const CourseList = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('all'); // State for category filter

  // Simulate fetching data (replace with API call later)
  useEffect(() => {
    setLoading(true);
    try {
      // In a real app: fetch('/api/courses').then(res => res.json())
      setCourses(allCoursesData);
      setError(null);
    } catch (err) {
      setError('Failed to load courses.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const getFilteredCourses = () => {
    if (filter === 'all') {
      return courses;
    }
    return courses.filter(course => course.category === filter);
  };

  const categories = ['All', ...new Set(allCoursesData.map(course => course.category))];
  const filteredCourses = getFilteredCourses();

  if (loading) return <p className={styles.loading}>Loading courses...</p>;
  if (error) return <p className={styles.error}>{error}</p>;

  return (
    <section className={styles.courseListSection} id='courseList'>
      <h2 className={styles.sectionHeading}>Our Comprehensive Course Catalog</h2>
      <p className="section-subtitle">
        Find the perfect program to kickstart or advance your tech career.
      </p>

      {/* Optional: Category Filters */}
      <div className={styles.filterContainer}>
        {categories.map(cat => (
          <button
            key={cat}
            className={`${styles.filterButton} ${filter === cat ? styles.active : ''}`}
            onClick={() => setFilter(cat === 'All' ? 'all' : cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Conditionally apply the CSS class based on the number of filtered courses */}
      <div className={filteredCourses.length === 1 ? styles.singleCourseGrid : styles.coursesGrid}>
        {filteredCourses.map((course, index) => (
          <CourseCardDetailed key={course.id} course={course} style={{ animationDelay: `${index * 0.1}s` }} />
        ))}
      </div>
      {filteredCourses.length === 0 && <p className={styles.noCourses}>No courses found in this category.</p>}
    </section>
  );
};

export default CourseList;